'use strict';

import { BaseElement } from "../interfaces/BaseElement";
import gsap from 'gsap';
import {setLordIcon} from "../../lordicon";
import {isDesktop, isMobile, settingsData} from "../../settings";
import {asideHandler, getActiveMenuData} from "../menu/menu";
import {changeLangToCurrent, getCurrentLangDirection} from "./langSwitcher/langSwitcher";
import {lockScreenOrientation} from "../../functions";
import {BmbyMode} from "../mode/BmbyMode";

export class VideoPopUp extends BaseElement {
  static #root;
  #active = false;
  #obsticleRect = {
    width: 0,
    height: 0
  };
  targetElement = isMobile
    ? document.querySelector('.additional-menu__item[data-menu-item="More"]')
    : isDesktop
      ? document.querySelector('.aside__navigation_list .aside__navigation-menu__item[data-menu-item="documents"]')
      : document.querySelector('.aside__navigation_list .aside__navigation-menu__item[data-menu-item="gallery"]');
  #key = 'playBouncy';
  #dictKey = 'Video';

  constructor() {
    super();

    if (!config.features?.videoPopUp?.active || BmbyMode.active) {
      return;
    }
    this.#active = true;

    VideoPopUp.#root = this;
    this.#createVideoPopUp();
    this.#createVideoMenuItem();
    this.#addMenuResizeCallback();

    if (!config.features?.videoPopUp?.type) {
      config.features.videoPopUp.type = 'popup';
    }

    if (config.features?.videoPopUp?.type && config.features.videoPopUp.type !== 'menu' && !isMobile) {
      setTimeout(() => {
        this.#clickHandler();
        lockScreenOrientation();
      }, config.features.videoPopUp.delay * 1000);
    }

    return this;
  }

  static isOpen() {
    const videoPopUpElement = document.querySelector('.video-pop-up');
    if (!videoPopUpElement || !VideoPopUp.#root)
      return false;
    return VideoPopUp.#root.getAttribute('state') === 'expanded' ? true : false;
  }

  static close() {
    if (VideoPopUp.isOpen()) {
      VideoPopUp.#root.#clickHandler();
    }
  }

  static open() {
    if (!VideoPopUp.#root) {
      new VideoPopUp();
    }else if (!VideoPopUp.isOpen()) {
      VideoPopUp.#root.#clickHandler();
    }
  }

  static shrink() {
    if (VideoPopUp.#root.getAttribute('state') === 'expanded' && VideoPopUp.#root.getAttribute('type') === 'popup' && !isMobile) {
      VideoPopUp.#root.#clickResizeHandler();
    }
  }

  static isPlaying() {
    const video = VideoPopUp.getVideoElement();
    if (!video)
      return false;
    const isIframe = video.tagName === 'IFRAME';
    if (isIframe) {
      // let answer;

      // const messageReceiveCallback = (event) => {
      //   console.log('MESSAGE RECEIVED');
      //   console.log(event);
      //   answer = 0;
      //   if (event.origin !== 'https://www.youtube.com') return;
      //   const data = JSON.parse(event.data);
      //   if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
      //     answer = data.info.playerState === 1;
      //   }
      //   window.removeListener('message', messageReceiveCallback);
      // };

      // window.addEventListener('message', messageReceiveCallback);

      // video.contentWindow.postMessage('{"event":"command","func":"getPlayerState","args":""}', '*');

      // const interval = setInterval(() => {
      //   if (answer !== undefined) {
      //     clearInterval(interval);
      //     console.log(answer);
      //     return answer;
      //   }
      //   console.log('waiting');
      // }, 250);
      return true;
    } else {
      return !video.paused;
    }
  }

  static isActive() {
    if (!VideoPopUp.#root) {
      return false;
    }
    return VideoPopUp.#root.#active;
  }

  #resizeCallback = (entries) => {
    // const entry = entries[0];
    const menu = document.querySelector('.aside__container');
    const search = document.querySelector('.search__container-main');
    const menuBounds = menu.getBoundingClientRect();
    const searchBounds = search?.getBoundingClientRect();
    const currentDirection = getCurrentLangDirection();
    let menuWidth = currentDirection === 'ltr'
      ? menuBounds.right
      : window.innerWidth - menuBounds.left;
    let searchWidth = currentDirection === 'ltr'
      ? searchBounds?.right || 0
      : window.innerWidth - searchBounds?.left || 0;
    const activeMenu = getActiveMenuData();
    if (activeMenu !== '3dModel' && activeMenu !== 'search') {
      searchWidth = 0;
    }
    this.#obsticleRect.width = Math.max(menuWidth, searchWidth);
    this.#obsticleRect.height = activeMenu === 'search' ? getComputedStyle(this.DOMElement).getPropertyValue('--bottom-offset-in-search').split('px')[0] : 0;
    this.DOMElement.style.setProperty('--obstacle-width', this.#obsticleRect.width + 'px');
    this.DOMElement.style.setProperty('--obstacle-height', this.#obsticleRect.height + 'px');
  }

  static updateObsticleSize() {
    if (VideoPopUp.isActive()) {
      VideoPopUp.#root.#resizeCallback();
    }
  }

  static addSearchResizeCallback(search) {
    if (!VideoPopUp.#root || isMobile || isDesktop) {
      return;
    }
    const observer = new ResizeObserver(this.#root.#resizeCallback);
    observer.observe(search);
  }
  
  #addMenuResizeCallback() {
    if (isMobile || isDesktop) {
      return;
    }
    const menu = document.querySelector('.aside__container');
    const observer = new ResizeObserver(this.#resizeCallback);
    observer.observe(menu);
  }

  static getVideoElement() {
    return VideoPopUp.#root?.DOMElement.querySelector('.video-pop-up__video');
  }

  #createVideoPopUp() {
    this.addClass('video-pop-up')
      .appendTo(document.body);

    const wrapper = new BaseElement()
      .addClass('video-pop-up__wrapper', 'hidden')
      .appendTo(this.DOMElement);
    
    let closeButton;

    if (isMobile) {
      this
        .addClass('background-backdrop-filter')
        .addAttribute('type', 'popup')
        .addAttribute('state', 'expanded');
      wrapper.removeClass('hidden');
      
      closeButton = new BaseElement('button')
        .addClass('close-button-cross', 'video-pop-up__close-button', 'hidden')
        .event('click', this.#clickHandler.bind(this))
        .appendTo(wrapper.DOMElement);
    }else {
      this
        .addAttribute('type', config.features.videoPopUp.type !== 'shrinked' ? 'popup' : 'shrinked')
        .addAttribute('state', 'collapsed');
      
      const titleBar = new BaseElement()
        .addClass('video-pop-up__title-bar', 'background-backdrop-filter')
        .appendTo(wrapper.DOMElement);

      new BaseElement('button')
        .addClass(this.getAttribute('type') === 'shrinked' ? 'icon-fullscreen-arrows' : 'icon-fullscreen-arrows-2')
        .addClass('video-pop-up__resize-button')
        .event('click', this.#clickResizeHandler.bind(this))
        .appendTo(titleBar.DOMElement);

      new BaseElement('button')
        .addClass('icon-close', 'video-pop-up__close-button')
        .event('click', this.#clickHandler.bind(this))
        .appendTo(titleBar.DOMElement);
    }

    if (config.features?.videoPopUp?.url.indexOf('youtube') > -1) {
      new BaseElement('iframe')
        .addClass('video-pop-up__video')
        .event('ended', this.#clickHandler.bind(this))
        .event('load', () => closeButton?.removeClass('hidden'))
        .setAttributes({
          'src': config.features?.videoPopUp?.url + '?enablejsapi=1',
          'allowFullScreen': true,
          'autoplay': true,
          'frameBorder': '0',
          'allow': "encrypted-media; gyroscope"
        })
        .appendTo(wrapper.DOMElement);
    } else {
      const video = new BaseElement('video')
        .addClass('video-pop-up__video')
        .event('ended', this.#clickHandler.bind(this))
        .event('load', () => closeButton?.removeClass('hidden'))
        .setAttributes({
          'controls': true,
          'autoplay': true
        })
        .appendTo(wrapper.DOMElement);
      new BaseElement('source')
        .addAttribute('src', config.features?.videoPopUp?.url)
        .appendTo(video.DOMElement);
      video.DOMElement.muted = 'muted';
    }
  }

  #createVideoMenuItem() {
    if (isMobile) {
      const navList = document.querySelector('.aside__navigation_list');
      const menuElements = [...navList.querySelectorAll('.aside__navigation-menu__item')];
      menuElements.forEach(element => { element.classList.add('horizontal-separator') });

      const videoMinimizedElement = new BaseElement('li')
        .addClass('aside__navigation-menu__item', 'mobile-menu-item')
        .event('click', this.#clickHandler.bind(this))
        .appendTo(navList);
      new BaseElement('span')
        .addClass('aside__navigation-menu__text', 'language-string', 'text', 'body')
        .addAttribute('data-dictionary', this.#dictKey)
        .innerHtml(changeLangToCurrent(this.#dictKey))
        .appendTo(videoMinimizedElement.DOMElement);
      const iconElement = new BaseElement('span')
        .addClass('aside__navigation-menu__icon')
        .appendTo(videoMinimizedElement.DOMElement)
      setLordIcon('playBouncy', iconElement.DOMElement, {trigger: 'hover',delay:'0'});
      return;
    }else {
      const menuItem = new BaseElement('li')
        .addClass('aside__navigation-menu__item');
      this.targetElement.after(menuItem.DOMElement);
      this.targetElement = menuItem.DOMElement;

      new BaseElement('span')
        .addClass('aside__navigation-menu__text', 'language-string', 'text', 'body')
        .innerHtml(changeLangToCurrent(this.#dictKey))
        .setAttributes({
          'data-dictionary': this.#dictKey,
          'data-menu-item': this.#key
        })
        .appendTo(menuItem.DOMElement);

      menuItem.addAttribute('data-menu-item', this.#key);

      const icon = new BaseElement('span')
        .addClass('aside__navigation-menu__icon')
        .appendTo(menuItem.DOMElement);
      setLordIcon('playBouncy', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
    }
  }

  #clickHandler(e) {
    let videoPopUpElement = document.querySelector('.video-pop-up');
    if (!videoPopUpElement) {
      videoPopUpElement = this.DOMElement;
    }
    if (isMobile) {
      asideHandler();
    }
    if (e) {
      e.stopPropagation();
    }

    const videoPopUpWrapper = videoPopUpElement.querySelector('.video-pop-up__wrapper');
    const videoPopUpState = videoPopUpElement.getAttribute('state');
    const video = videoPopUpElement.querySelector('.video-pop-up__video');
    const isIframe = video.tagName === 'IFRAME';
    const duration = isMobile && videoPopUpState === 'collapsed' ? 0 : 0.5;
    const bounds = this.targetElement 
      ? this.targetElement.getBoundingClientRect() 
      : {top: 0, left: 0, width: 0, height: 0};
    const targetTopPosition = bounds.top + bounds.height / 2;
    const targetLeftPosition = bounds.left + bounds.width / 2;

    switch(videoPopUpState) {
      case 'expanded':
        gsap.to(videoPopUpElement, {
          duration,
          top: targetTopPosition,
          left: targetLeftPosition,
          scale: 0,
          onStart: () => {
            if (isIframe) {
              video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else {
              video.pause();
              video.webkitExitFullscreen();
            }
          },
          onUpdate: () => {
            const progress = gsap.getProperty(videoPopUpElement, 'scale');
            videoPopUpElement.style.transform = `translate(-50%, -50%) scale(${progress})`;
          },
          onComplete: () => {
            videoPopUpElement.setAttribute('state', 'collapsed');
            videoPopUpWrapper.classList.add('hidden');
            lockScreenOrientation();
          }
        });
        break;
      case 'collapsed':
        const dummyElement = new BaseElement()
          .addClass('video-pop-up')
          .addAttribute('type', config.features.videoPopUp.type !== 'shrinked' ? 'popup' : 'shrinked')
          .addAttribute('state', 'expanded')
          .addAttribute('style', `--obstacle-width: ${this.#obsticleRect.width}px; --obstacle-height: ${this.#obsticleRect.height}px;`)
          .appendTo(document.body);
        const dummyBounds = dummyElement.DOMElement.getBoundingClientRect();
        const newTargetTopPosition = dummyBounds.top + dummyBounds.height / 2;
        const newTargetLeftPosition = dummyBounds.left + dummyBounds.width / 2;
        dummyElement.remove();
        videoPopUpElement.style.top = targetTopPosition + 'px';
        videoPopUpElement.style.left = targetLeftPosition + 'px';
        videoPopUpElement.style.transform = 'translate(-50%, -50%) scale(0)';
        videoPopUpElement.setAttribute('type', config.features.videoPopUp.type !== 'shrinked' ? 'popup' : 'shrinked');
        if (isMobile) {
          videoPopUpElement.setAttribute('type', 'popup');
        }
        videoPopUpWrapper.classList.remove('hidden');
        gsap.to(videoPopUpElement, {
          duration: duration * 0.5,
          top: newTargetTopPosition,
          left: newTargetLeftPosition,
          scale: 1,
          onStart: () => {
            const resizeBtn = videoPopUpElement.querySelector('.video-pop-up__resize-button');
            resizeBtn?.classList.remove('icon-fullscreen-arrows');
            resizeBtn?.classList.remove('icon-fullscreen-arrows-2');
            resizeBtn?.classList.add(config.features.videoPopUp.type !== 'shrinked' ? 'icon-fullscreen-arrows-2' : 'icon-fullscreen-arrows');
          },
          onComplete: () => {
            videoPopUpElement.setAttribute('state', 'expanded');
            videoPopUpElement.setAttribute('style', '');
            this.#resizeCallback();
          }
        });
    }
  }

  #clickResizeHandler() {
    const videoPopUpElement = document.querySelector('.video-pop-up');
    if (!videoPopUpElement)
      return;

    const videoPopUpType = videoPopUpElement.getAttribute('type');
    const videoPopUpResize = videoPopUpElement.querySelector('.video-pop-up__resize-button');
    const duration = 0.25;

    const dummyElement = new BaseElement()
      .addClass('video-pop-up')
      .addAttribute('type', videoPopUpType === 'shrinked' ? 'popup' : 'shrinked')
      .addAttribute('state', 'expanded')
      .addAttribute('style', `--obstacle-width: ${this.#obsticleRect.width}px; --obstacle-height: ${this.#obsticleRect.height}px;`)
      .appendTo(document.body);
    const dummyBounds = dummyElement.DOMElement.getBoundingClientRect();
    const targetTopPosition = dummyBounds.top + dummyBounds.height / 2;
    const targetLeftPosition = dummyBounds.left + dummyBounds.width / 2;
    const targetWidth = dummyBounds.width;
    const targetHeight = dummyBounds.height;
    dummyElement.remove();
    
    switch(videoPopUpType) {
      case 'popup':
        gsap.to(videoPopUpElement, {
          duration,
          width: targetWidth,
          height: targetHeight,
          top: targetTopPosition,
          left: targetLeftPosition,
          onComplete: () => {
            videoPopUpElement.setAttribute('type', 'shrinked');
            videoPopUpResize.classList.remove('icon-fullscreen-arrows-2');
            videoPopUpResize.classList.add('icon-fullscreen-arrows');
            videoPopUpElement.setAttribute('style', '');
            this.#resizeCallback();
          }
        });
        break;
      case 'shrinked':
        gsap.to(videoPopUpElement, {
          duration,
          width: targetWidth,
          height: targetHeight,
          top: targetTopPosition,
          left: targetLeftPosition,
          onStart: () => {
            const currentBounds = videoPopUpElement.getBoundingClientRect();
            const currentTopPosition = currentBounds.top + currentBounds.height / 2;
            const currentLeftPosition = currentBounds.left + currentBounds.width / 2;
            videoPopUpElement.style.top = currentTopPosition + 'px';
            videoPopUpElement.style.left = currentLeftPosition + 'px';
          },
          onComplete: () => {
            videoPopUpElement.setAttribute('type', 'popup');
            videoPopUpResize.classList.remove('icon-fullscreen-arrows');
            videoPopUpResize.classList.add('icon-fullscreen-arrows-2');
            videoPopUpElement.setAttribute('style', '');
          }
        });
        break;
    }
  }
}
